import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
// Удаляем импорт Font Awesome из npm
// import '@fortawesome/fontawesome-free/css/all.min.css'
import socket from './plugins/socket'

// Настройка базового URL для axios
axios.defaults.baseURL = (process.env.VUE_APP_API_URL + '/api') || 'http://localhost:3000'

// Добавление перехватчика запросов для добавления токена авторизации
axios.interceptors.request.use(config => {
  const token = store.getters.authToken
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// Добавление перехватчика ответов для обработки ошибок авторизации
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      console.log('Ошибка авторизации, выход из системы')
      store.dispatch('logout')
      router.push('/login')
    }
    return Promise.reject(error)
  }
)

// Директива для закрытия выпадающего списка при клике вне элемента
const clickOutside = {
  mounted(el, binding) {
    el._clickOutside = (event) => {
      if (!(el === event.target || el.contains(event.target))) {
        binding.value(event);
      }
    };
    document.addEventListener('click', el._clickOutside);
  },
  unmounted(el) {
    document.removeEventListener('click', el._clickOutside);
  }
};

// Проверка авторизации перед переходом на защищенные маршруты
router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters.isAuthenticated
  
  if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {
    next('/login')
  } else if (to.path === '/login' && isAuthenticated) {
    next('/')
  } else {
    next()
  }
})

// Подключение к WebSocket, если пользователь авторизован
if (store.getters.isAuthenticated) {
  socket.connect()
}

// Создание и монтирование приложения
const app = createApp(App)
app.directive('click-outside', clickOutside)
app.use(router)
app.use(store)
app.mount('#app')
